import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContextProvider";
import { JSONTree } from "react-json-tree";
export function SaveMetadata({ metadata }) {
    const [isDark, setIsDark] = useState(true);
    //const [isConnected, setConnected] = useState(false);
    const context = useContext(AppContext);
    useEffect(() => {
        if (document.documentElement.getAttribute("data-color-mode") === "dark" ||
            document.documentElement.getAttribute("data-color-mode") === null) {
            setIsDark(true);
        }
        else {
            setIsDark(false);
        }
        //setConnected(isConnected())
    }, [context.getState()?.isRender /*, isConnected()*/]);
    return (_jsx(_Fragment, { children: _jsx("div", { style: { display: "flex", justifyContent: "center" }, children: _jsx("div", { style: { textAlign: "left" }, children: _jsx(JSONTree, { data: metadata, theme: "twilight", invertTheme: !isDark }) }) }) }));
}
